export const questionContinueBtnDataSet = { cy: 'question-continue-btn' };
export const addAnswerBtnDataSet = { cy: 'question-add-answer-btn' };
